<template>
  <el-container
    class="userManagement-box"
    v-loading="loading"
    direction="vertical"
  >
    <div class="check-info">
      <div class="check-info_btn">
        <el-button type="primary" size="medium" @click="checkAllReport"
          >查看体检报告</el-button
        >
      </div>
      <div class="check-info_main">
        <!-- <div class="check-info_title">检查信息</div> -->
        <div class="check-info_data">
          <div
            v-if="!isNullObj"
            ref="suggestionPanel"
            tag="ul"
            view-class="el-cascader__suggestion-list"
            style="height: 100%; width: 100%"
            class="scroll-wrapper"
          >
            <div
              v-for="(val, key, index) in infoData"
              :key="index"
              class="check-info_item"
            >
              <div v-for="(v, k, i) in val" :key="i">
                <div class="check-info_name">{{ k }}</div>
                <div
                  class="check-info_card"
                  v-for="(vChild, kChild, iChild) in v"
                  :key="iChild"
                >
                  <p class="card-title">{{ kChild }}</p>
                  <div
                    class="card-data"
                    v-for="item in vChild"
                    :key="item.baseDataItemCode"
                  >
                    <template v-if="key == 60">
                      <el-popover
                        v-if="item.baseDataItemNameShow.length > 8"
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        :content="item.baseDataItemNameShow"
                      >
                        <p class="name-box">
                          <span class="name" slot="reference">{{
                            item.baseDataItemNameShow
                          }}</span>
                        </p>
                      </el-popover>
                      <template v-else>
                        <p class="name-box">
                          <span class="name">{{
                            item.baseDataItemNameShow
                          }}</span>
                        </p>
                      </template>
                      <el-my-popover
                        class="value"
                        :item="formatItem(item)"
                        :value="item.baseDataValue"
                      ></el-my-popover>
                      <span class="unit">{{ item.unit }}</span>
                    </template>
                    <template v-else-if="key == 70">
                      <p class="name-box">
                        <span>{{ item.baseDataItemNameShow }}</span>
                      </p>
                      <el-my-popover
                        class="value"
                        :item="formatItem(item)"
                        :value="item.baseDataValue"
                      ></el-my-popover>
                      <span class="unit">{{ item.unit }}</span>
                    </template>
                    <template v-else>
                      <el-popover
                        v-if="item.baseDataItemNameShow.length > 8"
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        :content="item.baseDataItemNameShow"
                      >
                        <span class="name" slot="reference">{{
                          item.baseDataItemNameShow
                        }}</span>
                      </el-popover>
                      <span class="name" v-else>{{
                        item.baseDataItemNameShow
                      }}</span>
                      <el-my-popover
                        class="long"
                        :item="formatItem(item)"
                        :value="item.baseDataValue"
                      ></el-my-popover>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-empty
            v-if="isNullObj && !loading"
            class="empty"
            description="暂无数据"
          ></el-empty>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import {
  getUserDocRecordDetailByProfileId,
  getUserDocRecordDetailByPhoneNumber,
} from "@/config/healthApi.js";
import elMyPopover from "../health/components/elMyPopover.vue";

export default {
  name: "health-examination-info",
  components: {
    elMyPopover,
  },
  data() {
    return {
      infoData: {},
      loading: true,
    };
  },
  computed: {
    isNullObj() {
      if (JSON.stringify(this.infoData) == "{}") {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      this.loading = true;
      this.infoData = {};
      try {
        let res = null;
        let { isChannelArchive, phone } = this.$store.state.healthDocUser;
        if (isChannelArchive) {
          res = await getUserDocRecordDetailByProfileId({
            userId: this.$store.state.healthDocUser.userId,
          });
        } else {
          res = await getUserDocRecordDetailByPhoneNumber({
            phoneNum: phone,
          });
        }
        if (res && res.code == 200) {
          this.infoData = res.data || {};
        }
        // 无体检数据或接口异常：仅展示空态，不弹错误
      } catch (e) {
        this.infoData = {};
      } finally {
        this.loading = false;
      }
    },
    formatItem(item) {
      return {
        dataItem: item.baseDataItem,
        dataItemCode: item.baseDataItemCode,
      };
    },
    checkAllReport() {
      this.$router.push({
        name: !this.$store.state.healthDocUser.isDoc
          ? "体检信息列表"
          : "体检信息列表D",
        query: {
          type: "report",
        },
      });
    },
  },
};
</script>
<style lang="scss">
.check-info {
  .scroll-wrapper .el-scrollbar__thumb {
    border-radius: 4px;
    width: 4px;
  }
}
</style>
<style lang="scss" scoped>
@import "@/assets/css/color.scss";
.userManagement-box {
  padding: 0 !important;
  min-height: 500px;
  overflow-y: hidden;
}
.check-info {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  position: relative;
  padding-top: 10px;
  background-size: 100% 100%;
  &_btn {
    position: absolute;
    margin: 0 0 15px 0;
    right: 0;
    z-index: 99;
    // top: 10px;
  }
  &_main {
    // height: 100%;
    flex: 1;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
  }
  &_title {
    box-sizing: border-box;
    // padding-right: 67px;
    padding-bottom: 30px;
    display: flex;
    align-items: center;
    // margin: 28px 0 0px 48px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    // color: #00f6ff;
    line-height: 25px;
    &::before {
      content: "";
      display: inline-block;
      width: 3px;
      height: 18px;
      // background: #00f6ff;
      margin-right: 8px;
    }
  }
  &_data {
    box-sizing: border-box;
    width: 100%;
    // padding-right: 37px;
    flex: 1;
    &:last-child {
      margin-bottom: 30px;
    }
  }
  &_item {
    margin: 0 0 32px 0;
  }
  &_name {
    // margin: 0px 0 28px 60px;
    height: 30px;
    line-height: 30px;
    font-weight: bold;
    padding-left: 20px;
    position: relative;
    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 8px;
      background-color: $theme;
    }
  }
  &_card {
    position: relative;
    box-sizing: border-box;
    // background: rgba(255, 255, 255, 0.06);
    border: 1px solid #ebebeb;

    display: flex;
    flex-wrap: wrap;
    padding-top: 29px;
    margin: 38px 0 0 0;
    &::before {
      position: absolute;
      left: 0;
      top: 0;
      display: block;
      content: "";
      width: 199px;
      height: 100%;
    }
    .card-title {
      position: absolute;
      left: 24px;
      top: -13px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      // color: #ffffff;
      line-height: 25px;
    }
    .card-data {
      position: relative;
      display: flex;
      align-items: flex-start;
      width: 50%;
      margin-bottom: 16px;
      box-sizing: border-box;
      padding-right: 100px;
      &:nth-child(even) {
        padding-left: 40px;
      }
      .name-box {
        flex: 1;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        // color: #ffffff;
        line-height: 20px;
        text-align: left;
      }
      .name {
        width: 56px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        // color: #ffffff;
        display: inline-block;
        // text-align: left;
        text-align: justify;
        text-justify: distribute-all-lines; /*ie6-8*/
        text-align-last: justify; /* ie9*/
        -moz-text-align-last: justify; /*ff*/
        -webkit-text-align-last: justify; /*chrome 20+*/
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .value {
        display: flex;
        justify-content: flex-end;
        // align-items: flex-end;
        width: 30%;
        // text-align: right;
      }
      .unit {
        margin-left: 16px;
        width: 60px;
        // color: rgba(255, 255, 255, 0.9);
        text-align: left;
      }
      .long {
        text-align: left;
        flex: 1;
        margin-left: 14px;
        // color: rgba(255, 255, 255, 0.9);
      }
      .expire {
        position: absolute;
        right: 46px;
        top: 0;
      }
      .timeout {
        img {
          width: 18px;
          height: 18px;
          display: block;
        }
      }
    }
  }
}
.el-empty {
  margin-top: 80px;
}
</style>
